import React from 'react';
import { SettingSlider } from '../../Sliders';
import { TEXT_SETTINGS_MORE, TEXT_SETTINGS_OUTLINE } from '../constants';

import './settingsOutline.scss'
import { ColorArray } from '../../ColorArray';
import { useOutlineSettings } from '../../../LeftWorkArea/LeftWorkOutline/useOutlineSettings';

export const SettingsOutline = () => {

    const { changeColor, changeWeight, outline } = useOutlineSettings()

    return <div className='settings-outline'>
        <SettingSlider {...TEXT_SETTINGS_OUTLINE.weight} onChange={changeWeight} value={outline.weight} />
        <ColorArray defaultColor={outline.color} onColorSelected={changeColor} />
    </div>
}